import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnimatedElement = ({
  children,
  fromDirection = "top",
  className,
  style,
  disableAnimation = false, 
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const variants = {
    top: {
      hidden: { opacity: 0, y: -200 },
      visible: { opacity: 1, y: 0, transition: { duration: 1 } },
    },
    topSlow: {
      hidden: { opacity: 0, y: -500 },
      visible: { opacity: 1, y: 0, transition: { duration: 4 } },
    },
    bottom: {
      hidden: { opacity: 0, y: 200 },
      visible: { opacity: 1, y: 0, transition: { duration: 1 } },
    },
    left: {
      hidden: { opacity: 0, x: -300 },
      visible: { opacity: 1, x: 0, transition: { duration: 1 } },
    },
    right: {
      hidden: { opacity: 0, x: 300 },
      visible: { opacity: 1, x: 0, transition: { duration: 1 } },
    },
    custom: {
      hidden: { opacity: 0, x: 300, y: -200 },
      visible: { opacity: 1, x: 0, y: 0, transition: { duration: 1 } },
    },
    custom2: {
      hidden: { opacity: 0, x: 300, y: 200 },
      visible: { opacity: 1, x: 0, y: 0, transition: { duration: 1 } },
    },
    topbancos: {
      hidden: { opacity: 0, y: -500 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
    },
    topbancosservicios: {
      hidden: { opacity: 0, y: -900 },
      visible: { opacity: 1, y: 0, transition: { duration: 2 } },
    },
    topcajerosatm: {
      hidden: { opacity: 0, y: -900 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
    },
  };

  if (disableAnimation) {
    return (
      <div ref={ref} className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants[fromDirection]}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedElement;
